import React from "react";

interface TooltipProps {
  isVisible: boolean
  tooltipContent: React.ReactNode
}

export const Tooltip = (props: React.PropsWithChildren<TooltipProps>) => {
  return <span className="sone-tooltip-wrapper">
    {props.children}
    <div className="sone-tooltip-content" style={{
      visibility: props.isVisible ? "visible" : "hidden",
    }}>
      {props.tooltipContent}
    </div>
  </span>
}